import { NbMenuService } from '@nebular/theme';
import { Component } from '@angular/core';
import {Location} from '@angular/common';

@Component({
  selector: 'ngx-not-found',
  styleUrls: ['./not-found.component.scss'],
  templateUrl: './not-found.component.html',
})
export class NotFoundComponent {

  constructor(
    private menuService: NbMenuService,
    private _location: Location
  ) {
  }

  goToHome() {
    this.menuService.navigateHome();
  }

  goBack() {
    this._location.back();
  }
}
